/* eslint-disable */
export const VERSION = process.env.VUE_APP_VERSION
export const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT
export const APP_URL = process.env.VUE_APP_APP_URL
export const IFRAME_URL = process.env.VUE_APP_IFRAME_URL
export const NETWORK_LIST = process.env.VUE_APP_NETWORK_LIST
export const AVAILABLE_NETWORKS = `${process.env.VUE_APP_AVAILABLE_NETWORKS}`
